import { render, staticRenderFns } from "./MenuManageFood.vue?vue&type=template&id=77218828&scoped=true"
var script = {}
import style0 from "./MenuManageFood.vue?vue&type=style&index=0&id=77218828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77218828",
  null
  
)

export default component.exports